import { ShipmentSearchStatus } from '@/modules/pmt/interfaces';
import dynamic from 'next/dynamic';
import type { ITrackingEventDetailProps } from '../components/TrackingEventDetail';
import type { ITrackingEventNotFoundProps } from '../components/TrackingEventNotFound';

const TrackingEventLoader = dynamic<Record<string, unknown>>(async () =>
  import('../components/TrackingEventLoader').then((mod) => mod.TrackingEventLoader),
);

const TrackingEventDetailLoader = dynamic<ITrackingEventDetailProps>(async () =>
  import('../components/TrackingEventDetail').then((mod) => mod.TrackingEventDetail),
);

const TrackingEventNotFoundLoader = dynamic<ITrackingEventNotFoundProps>(async () =>
  import('../components/TrackingEventNotFound').then((mod) => mod.TrackingEventNotFound),
);

export const TrackingEventCardHeaderMapping: {
  [key in ShipmentSearchStatus]: React.ComponentType<any>;
} = {
  [ShipmentSearchStatus.Fetched]: TrackingEventDetailLoader,
  [ShipmentSearchStatus.Pending]: TrackingEventLoader,
  [ShipmentSearchStatus.ScrapingWithCarrier]: TrackingEventLoader,
  [ShipmentSearchStatus.Timeout]: TrackingEventNotFoundLoader,
};
